export default {
  title: 'Playturbo',
  payment: {
    button: 'パッケージを購入',
  },
  menu: {
    account: 'アカウント管理',
    template: 'マイプレイアブル',
    logout: 'ログアウト',
    subscribeTips: 'プレイアブル作成ツール',
  },
  nav: {
    delivery: '素材リスト',
    index: 'カスタムプレイ可能広告',
    commonTemplate: 'プレイアブル広告のテンプレート',
    videoImage: 'カスタム画像＆動画',
    report: 'レポート',
  },
  makerSwitch: {
    tools: 'ツールの選択',
    dmaker: 'クリエイティブをカスタマイズ',
    gmaker: 'プレイアブル広告の制作',
    vmaker: 'ビデオ広告の制作',
  },
  download: {
    dropdown: ['Mintegralにプッシュ', '他のチャネルにダウンロード'],
  },
  message: {
    notifications: 'システム通知',
    ignoreAll: 'すべて無視',
    viewAll: 'すべてのメッセージを表示',
    noNotification: '通知なし',
  },
}
